import React from 'react';

const InterviewEntryListPage = React.lazy(
  () => import('./interviewEntry/root'),
);
const InterviewEntryViewPage = React.lazy(
  () => import('./interviewEntry/id/view'),
);
const VideoPage = React.lazy(() => import('./video'));
const SelectGroupPage = React.lazy(() => import('./group/root'));
const SelectInterviewPage = React.lazy(() => import('./group/id'));
const EditInterviewPage = React.lazy(() => import('./group/id/interview/id'));

export enum Paths {
  InterviewEntryList = '/interview-entry',
  InterviewEntryView = '/interview-entry/:interviewEntryId/view',
  VideoPage = '/video/:videoUrl',
  SelectGroup = '/group',
  SelectInterview = '/group/:groupId',
  EditInterview = '/group/:groupId/interview/:interviewId?',
}

export const routes = [
  {
    path: Paths.InterviewEntryList,
    exact: true,
    component: InterviewEntryListPage,
  },
  {
    path: Paths.InterviewEntryView,
    exact: false,
    component: InterviewEntryViewPage,
  },
  {
    path: Paths.VideoPage,
    exact: false,
    component: VideoPage,
  },
  {
    path: Paths.SelectGroup,
    exact: true,
    component: SelectGroupPage,
  },
  {
    path: Paths.SelectInterview,
    exact: true,
    component: SelectInterviewPage,
  },
  {
    path: Paths.EditInterview,
    exact: true,
    component: EditInterviewPage,
  },
];
